import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoHeader from "../../components/LogoHeader";
import Button from "../../components/Button";
import Input from "../../components/Input";
import { LoadingContainer } from "../../containers/loadingContainer";
import "./styles.css";
import Header from "../../components/Header";
import { PresenceIndicatorContainer } from "../../containers/presenceIndicatorContainer";

const JoinView = ({
  onStartConnecting,
  isConnected,
  isConnectedToASession,
  onRequestJoinRoom,
  noRoomFound,
  isLoading,
  isEstablishingConnection,
  connectionQualityFailed,
}) => {
  const [roomName, setRoomName] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnected && !isEstablishingConnection) {
      onStartConnecting();
    }
  }, [isConnected, isEstablishingConnection]);

  useEffect(() => {
    if (connectionQualityFailed) {
      navigate("/");
    }
  }, [connectionQualityFailed]);

  useEffect(() => {
    if (isConnectedToASession) {
      navigate("/app");
    }
  }, [isConnectedToASession]);

  const handleJoinRoom = () => {
    if (roomName.length > 0 && userName.length > 0) {
      onRequestJoinRoom({
        roomName: roomName.toLowerCase(),
        userType: "",
        userName,
      });
      setRoomName("");
    }
  };

  if (isLoading || isEstablishingConnection) {
    return <LoadingContainer />;
  }

  return (
    <>
      <PresenceIndicatorContainer />
      <div className="container column">
        <div>
          <Header />

          <h2 className="create-title">Join an existing session</h2>

          <div className="join-type-col column">
            <p className="create-menu-text">Type your name and the room id, then click "Join" to enter the session</p>

            <div className="join-input-container ">
              <p className="label-text dark">Name:</p>
              <input
                placeholder="Your name"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="handmol-search-input"
              />
            </div>

            <div className="join-input-container row">
              <p className="label-text dark">Room ID:</p>
              <input
                placeholder="Room ID provided by host"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
                className="handmol-search-input"
              />
            </div>

            {noRoomFound && <p className="text-description error">We coudln't find that room. Please try again.</p>}

            <Button
              className="pdb-action-btn"
              handleClick={handleJoinRoom}
              disabled={roomName.length === 0 || userName.length === 0}
            >
              Join
            </Button>
          </div>
        </div>
        <p className="footer">
          © 2025 MolecularWebXR. All rights reserved. Part of the{" "}
          <a
            href="https://molecularweb.org"
            target="_blank"
            rel="noopener noreferrer"
            className="create-menu-text link"
          >
            Molecularweb.org
          </a>{" "}
          universe
        </p>
      </div>
    </>
  );
};

export default JoinView;
